import { Portfolio } from './../../models/Portfolio';
import { Component, Input } from '@angular/core';
import { Coin } from '../../models/Coin';
import { CoinsProvider } from '../../providers/coins/coins';

/**
 * Generated class for the PortfolioItemComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'portfolio-item',
  templateUrl: 'portfolio-item.html'
})
export class PortfolioItemComponent {

  @Input('coin') coin: Coin;
  @Input('portfolio') portfolio: Portfolio;

  text: string;

  constructor(public CP: CoinsProvider) {
    this.text = 'Hello World';
  }

}



// WEBPACK FOOTER //
// ./src/components/portfolio-item/portfolio-item.ts